/**
 * Backwards-compat shim. Re-export `useNewAuthStore` as `useAuthStore`
 * để 50+ callsites cũ tiếp tục hoạt động mà không phải đổi import.
 *
 * New code SHOULD dùng `useNewAuthStore` trực tiếp từ `@/store/use-new-auth-store`.
 */
export { useNewAuthStore as useAuthStore } from './use-new-auth-store';
